module.exports = __webpack_public_path__ + "img/Identity.1da33280.svg";